
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { translate } from 'react-i18next'
import { withStyles } from '@material-ui/core/styles'
import * as actions from '../../../../actionTypes'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import InputAdornment from '@material-ui/core/InputAdornment'
import Search from '@material-ui/icons/Search'
import Autocomplete from './Autocomplete'


const styles = theme => ({
  highEmphasis: {color: theme.typography.highEmphasis},
  root: {flexGrow: 1}
})


class SessionByCaseId extends Component {
  constructor(props) {
    super(props)
    this.state = {
      sessionIDs: []
    }
  }

  componentWillReceiveProps = nextProps => {
    if (nextProps.sessionIDs !== this.props.sessionIDs) {
      this.setState({sessionIDs: nextProps.sessionIDs})
    }
  }

  requestMatchingSessionIDs = e => {
    if (e.target.value !== '') {
      if (e.keyCode !== 38 && e.keyCode !== 40) {
        this.props.requestMatchingSessionIDs(e.target.value)
      }
    } else {
      this.setState({sessionIDs: []})
    }
  }

  recall = sessionId => {
    const session = this.state.sessionIDs.find(ele => ele.sessionId === sessionId)
    this.props.recallSession(session)
  }

  render() {
    const {classes, t } = this.props
    return (
      <Grid
        container
        justify="center"
        spacing={24}
      >
        <Grid item xs={10}>
          <Typography variant="subheading">
            <span className={classes.highEmphasis}>
              {t('Recall Session or Report by Case ID')}
            </span>
          </Typography>
        </Grid>
        <Grid item xs={10}>
          <Autocomplete
            items={this.state.sessionIDs}
            InputProps={{
              autoFocus: true,
              endAdornment: (
                <InputAdornment position="end">
                  <Search/>
                </InputAdornment>
              ),
              id: 'caseIdSearch',
              onKeyUp: this.requestMatchingSessionIDs,
              placeholder: t('Enter Case ID')
            }}
            maxItemsDisplayed={10}
            onChange={sessionId => this.recall(sessionId)}
          />
        </Grid>
      </Grid>
    )
  }
}

const mapStateToProps = state => ({
  sessionIDs: state.counselingSession.matchingSessionIDs,
})

const mapDispatchToProps = dispatch => ({
  requestMatchingSessionIDs(sessionId) {
    const action = {type: actions.MATCHING_SESSION_IDS_REQUESTED, payload: {sessionId}}
    dispatch(action)
  },
})

SessionByCaseId.propTypes = {
  recallSession: PropTypes.func,
  requestMatchingSessionIDs: PropTypes.func,
  classes: PropTypes.object,
  t: PropTypes.func
}

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  translate(),
  withStyles(styles)
)(SessionByCaseId)



// WEBPACK FOOTER //
// ./src/components/setup/recall-session/by-case-id/ByCaseId.js